import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({accountsData}) {
    const { AccountTags } = accountsData;
    return {
        AccountTags
    };
}
function mapDispatchToProps(dispatch) {
    return {
      
    };
}

class Affarsmojlighet extends Component {
  state={
    Typ:this.props.Typ
  }  
  componentDidUpdate=()=>{
    if(this.state.Typ !== this.props.Typ){
      
      this.setState({
        Typ:this.props.Typ
      })
    }
  }
  onChangeHandle=(e)=>{
    this.setState({
      Typ:e.target.value
    })
    this.props.handleChange(this.props.Meta,e.target.value)
  }
  render() {
       return (
          <div style={{ height: 'auto', paddingTop: '10px' }}>
                {
                    isEmpty(this.props.AccountTags)?"":
                
              <TextField
              variant="outlined"
              fullWidth
              label={<IntlMessages id="Input.Tagg.label"/>}
              size="small"
              name="type"
              error={parseInt(this.state.Typ)===0}
              select
              value={this.state.Typ}
              SelectProps={{native: true,}}
              InputLabelProps={{shrink: true,}}
              onChange={this.onChangeHandle}
            >
              <option Key="0" selected value={0}><IntlMessages id="Choose"/></option>
          {
          this.props.AccountTags.map((option,index) => (
            <option key={index} value={option.Keyword}>
              {option.Keyword}
            </option>
          ))}
            </TextField>  
            }
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(Affarsmojlighet);